import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(["spinner-border", $props.extraCssClass]),
    role: "status"
  }, _cache[0] || (_cache[0] = [_createElementVNode("span", {
    "class": "visually-hidden"
  }, "Loading...", -1)]), 2);
}